import React from 'react'
import Card from 'react-bootstrap/Card'
import { ImPointRight } from 'react-icons/im'

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: 'justify' }}>
            Hi Everyone, I am{' '}
            <span className="purple">Kelvin Moses a Frontend Engineer </span>
            based in <span className="purple"> Adamawa, Nigeria.</span>
            <br />I am a recent graduate with BSC,ED Computer Science from
            Taraba State Univesiry Jalingo.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Reading articles
            </li>
            <li className="about-activity">
              <ImPointRight /> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: 'rgb(155 126 172)' }}>
            "Dream is not what you see when you sleep, dream is what keep you
            awake while other's are asleep!"{' '}
          </p>
          <footer className="blockquote-footer">Kelvin</footer>
        </blockquote>
      </Card.Body>
    </Card>
  )
}

export default AboutCard
